import card1 from '../assets/image-video-1.png';
import card10 from '../assets/image-video-10.png';
import card11 from '../assets/image-video-11.png';
import card12 from '../assets/image-video-12.png';
import card13 from '../assets/image-video-13.png';
import card2 from '../assets/image-video-2.png';
import card3 from '../assets/image-video-3.png';
import card4 from '../assets/image-video-4.png';
import card5 from '../assets/image-video-5.png';
import card6 from '../assets/image-video-6.png';
import card7 from '../assets/image-video-7.png';
import card8 from '../assets/image-video-8.png';
import card9 from '../assets/image-video-9.png';

export const cardsSegredos = [
  {
    imgCard: card1,
    linkVideoCard: 'https://www.youtube.com/embed/Uq5QpZCi6P4?enablejsapi=1',
    title: 'Veja as dicas para criar e fortalecer clientes',
  },
  {
    imgCard: card2,
    linkVideoCard: 'https://www.youtube.com/embed/XYJbHADv89E?enablejsapi=1',
    title: 'Como se reinventar e pensar na equipe, no cliente e no caixa',
  },
  {
    imgCard: card3,
    linkVideoCard: 'https://www.youtube.com/embed/tq2aC-u0K2U?enablejsapi=1',
    title: 'Aprenda como as redes sociais podem te ajudar em momentos de crise',
  },
  {
    imgCard: card4,
    linkVideoCard: 'https://www.youtube.com/embed/-FSFJud4NPo?enablejsapi=1',
    title: 'Veja como tomar decisões para se reinventar na crise',
  },
  {
    imgCard: card5,
    linkVideoCard: 'https://www.youtube.com/embed/DcFhfxnld1A?enablejsapi=1',
    title: 'Como levar conteúdos presenciais para as plataformas digitais',
  },
  {
    imgCard: card6,
    linkVideoCard: 'https://www.youtube.com/embed/2X1LJbiI49I?enablejsapi=1',
    title: 'Dicas para fortalecer o seu delivery e tornar sua marca acessível',
  },
  {
    imgCard: card7,
    linkVideoCard: 'https://www.youtube.com/embed/8R3WMmCxjtY?enablejsapi=1',
    title: 'Cuide do caixa, reduza custos, repactue prazos e faça parcerias',
  },
  {
    imgCard: card8,
    linkVideoCard: 'https://www.youtube.com/embed/NTabRyB3r5o?enablejsapi=1',
    title: 'Tenha dicas de como se relacionar com as equipes durante a crise',
  },
  {
    imgCard: card9,
    linkVideoCard: 'https://www.youtube.com/embed/w92I4wPUjAs?enablejsapi=1',
    title: 'Mantenha as finanças da empresa estáveis e busque por resultados',
  },
  {
    imgCard: card10,
    linkVideoCard: 'https://www.youtube.com/embed/bY3naEFqw9A?enablejsapi=1',
    title: 'Veja como ampliar o seu público e criar novas oportunidades',
  },
  {
    imgCard: card11,
    linkVideoCard: 'https://www.youtube.com/embed/zY3I6Eqho1E?enablejsapi=1',
    title: 'Como minimizar o impacto da crise, planejar e fortalecer sua marca',
  },
  {
    imgCard: card12,
    linkVideoCard: 'https://www.youtube.com/embed/OZGtR1DP6qg?enablejsapi=1',
    title: 'Renove seus produtos para usar as mídias digitais e redes sociais',
  },
  {
    imgCard: card13,
    linkVideoCard: 'https://www.youtube.com/embed/ryPFNzxT_DA?enablejsapi=1',
    title: 'Fortaleça o seu marketing, crie um delivery e ajude a comunidade',
  },
];
